import FireMapContainer from "./FireMapContainer";

export default FireMapContainer;